/**
 * View for adding collaborators to an account. When instantiating, include
 * the following options:
 *      var myview = new AddCollaboratorDialog({
 *          model: account,   // the account we're granting roles TO
 *          collection: roles_coll, // collection of available roles
 *          accounts: accounts_coll // collection of accounts to search through
 *      })
 */
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import _ from 'underscore';
import $ from 'jquery';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/collaborator-add.hbs';

  var KEYUP_TIMEOUT_MS = 200;
  var view = Marionette.View.extend(DialogInterface).extend({
    template : Handlebars.compile(template),
    initialize :  function(options) {
        this.destroyOnClose();
        this.focusFirstInput();
        this.accounts = options.accounts;
        this.check_validation_db =
            _.debounce(this.check_validation, KEYUP_TIMEOUT_MS);
        this.success_callback = options.success;
    },
    ui: {
        alert: '.modal-alert-container > .alert',
        alertContainer: '.modal-alert-container',
        invite_by_email: 'form.invite-by-email',
        email_field: 'form.invite-by-email input[name=email]',
        roleCheckboxes: 'input[name="role"]',
        submitBtn: 'button[type="submit"]'
    },
    events: {
        'keyup @ui.email_field': 'on_email_keyup',
        'change @ui.email_field': 'check_validation',
        'change @ui.roleCheckboxes': 'check_validation',
        'submit @ui.invite_by_email': 'invite_by_email',
    },
    onRender: function() {
        if (!this.getSelectedRoles(this.ui.roleCheckboxes).length) {
            this.disableSubmit();
        }
        this.focusFirstInput();
    },
    disableSubmit: function() {
        this.$(this.ui.submitBtn).prop('disabled', true);
    },
    enableSubmit: function() {
        this.$(this.ui.submitBtn).prop('disabled', false);
    },
    has_valid_email: function() {
        return this.ui.email_field[0].value;
    },
    has_valid_roles: function() {
        var is_valid = this.getSelectedRoles(this.ui.roleCheckboxes).length > 0;
        return is_valid;
    },
    on_email_keyup: function(e) {
        this.check_validation_db();
    },
    check_validation: function(e) {
        if (this.has_valid_email() && this.has_valid_roles()) {
            this.enableSubmit();
        } else {
            this.disableSubmit();
        }
    },
    getSelectedRoles: function(form) {
        var fields = $(form).serializeArray();

        var selectedRoles = _.chain(fields)
            .filter(function(field) {
                return field.name === 'role';
            })
            .map(function(roleField) {
                return this.getOption('roles').get(roleField.value);
            }, this)
            .compact()
            .value();

        return selectedRoles;
    },
    invite_by_email: function(event) {
        event.preventDefault();
        this.hideAlert();

        var roles = this.getSelectedRoles(event.target);
        var fields = this.$(event.target).serializeArray();
        var email_field = _.findWhere(fields, { name: 'email' });

        // WARNING! Hacky!
        this.sent_values = {
            email: email_field.value,
            roles: roles
        };

        this.model.create_invitation(email_field.value, roles, {
            success: _.bind(this.on_success, this),
            error: _.bind(this.on_error, this),
            // Don't add the invitation to the collection until a response is received
            // (We want all of the target/grantee info to be attached to the model
            // before updating the collab collection, otherwise it will explode)
            wait: true
        });
    },
    on_success: function() {
        this.closeDialog();
        if (this.success_callback) this.success_callback(this.model, this.sent_values);
    },
    on_error: function(invitation, resp) {
        // Extract the first error we find and report it
        var err;
        try {
            err = resp.responseJSON.errors[0].detail;
        } catch (e) {
            console.error(e);
        }
        this.showAlert('error', err || 'Adding one or more roles failed');
    },
    templateContext: function() {
        var roles = this.getOption('roles').toJSON();
        var grantor = this.model.toJSON();
        return {
            grantor: grantor,
            roles: roles
        };
    }
  });
  export default view;

